// IMMEDIATE LOG - This should appear first if script loads
console.log('🔵 [main.tsx] Script file loaded and executing...');
console.log('🔵 [main.tsx] Document ready state:', document.readyState);
console.log('🔵 [main.tsx] Root element exists:', !!document.getElementById('root'));

// Enable verbose error logging BEFORE any imports
window.addEventListener('error', (event) => {
  console.error('🔴 === GLOBAL ERROR ===');
  // `window.error` can be either an ErrorEvent (script/runtime) or a plain Event (resource load error).
  if (event instanceof ErrorEvent) {
    console.error('Message:', event.message);
    console.error('Filename:', event.filename);
    console.error('Line:', event.lineno);
    console.error('Column:', event.colno);
    console.error('Error:', event.error);
    if (event.error?.stack) {
      console.error('Stack:', event.error.stack);
    }
  } else {
    const target = event.target as (EventTarget & { tagName?: string; src?: string; href?: string; currentSrc?: string }) | null;
    const tag = (target as any)?.tagName;
    const url = (target as any)?.currentSrc || (target as any)?.src || (target as any)?.href;
    console.error('Non-ErrorEvent:', { type: event.type, tag, url });
  }
  console.error('===================');
}, true); // Use capture phase

window.addEventListener('unhandledrejection', (event) => {
  console.error('🔴 === UNHANDLED PROMISE REJECTION ===');
  console.error('Reason:', event.reason);
  if (event.reason?.stack) {
    console.error('Stack:', event.reason.stack);
  }
  console.error('===================================');
});

console.log('🔵 [main.tsx] About to import React...');

import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { redirectToCanonicalHost } from './lib/site-url'

console.log('🔵 [main.tsx] Imports completed successfully');

// Log startup
console.log('🟢 [main] Starting application...');

if (redirectToCanonicalHost()) {
  console.log('🟢 [main] Redirecting to canonical host; skipping app boot');
} else {
  try {
    console.log('🟢 [main] Checking for root element...');
    const rootElement = document.getElementById("root");

    if (!rootElement) {
      console.error('🔴 [main] Root element NOT FOUND!');
      throw new Error('Root element not found! Make sure index.html has <div id="root"></div>');
    }

    console.log('🟢 [main] Root element found, creating React root...');
    const root = createRoot(rootElement);
    console.log('🟢 [main] React root created successfully');

    console.log('🟢 [main] Rendering App component...');
    root.render(<App />);

    console.log('🟢 [main] Application rendered successfully! ✅');
  } catch (error) {
    console.error('🔴 === FATAL ERROR DURING APP STARTUP ===');
    console.error('Error:', error);
    console.error('Error Type:', typeof error);
    console.error('Error Constructor:', error?.constructor?.name);
    console.error('Stack:', error instanceof Error ? error.stack : 'No stack trace');
    console.error('=====================================');

    const rootElement = document.getElementById("root");
    if (rootElement) {
      const errorHtml = `
        <div style="padding: 20px; font-family: monospace; background: #fee; border: 2px solid #f00; margin: 20px; color: #000;">
          <h1 style="color: #c00;">Fatal Error During Startup</h1>
          <pre style="white-space: pre-wrap; word-wrap: break-word;">${error instanceof Error ? error.toString() : String(error)}</pre>
          <p>Check the browser console (F12) for more details.</p>
          <p>Look for logs starting with 🔵, 🟢, or 🔴</p>
        </div>
      `;
      rootElement.innerHTML = errorHtml;
      console.error('🔴 [main] Error HTML injected into DOM');
    } else {
      console.error('🔴 [main] Cannot inject error - root element does not exist!');
    }
  }
}
